import crypto from 'crypto'

import { routeBase } from 'constants/environments.constants'

const environmentConfig = routeBase[process.env.REACT_APP_ENVIRONMENT] || {}

export const CryptoService = Object.freeze({
  SOAT: 'soat',
  USER_MANAGEMENT: 'userManagement',
})

const serviceCredentials = {
  [CryptoService.SOAT]: {
    key: environmentConfig.soatApiKey,
    iv: environmentConfig.soatApiIV,
  },
  [CryptoService.USER_MANAGEMENT]: {
    key: environmentConfig.userManagementApiKey,
    iv: environmentConfig.userManagementApiIV,
  },
}

const getServiceCredentials = (service) => {
  if (!service) {
    throw new Error('Encryption service identifier is required')
  }

  const credentials = serviceCredentials[service]

  if (!credentials?.key || !credentials?.iv) {
    throw new Error(`Encryption credentials not found for service: ${service}`)
  }

  return credentials
}

export function encryptData(text, service) {
  const { key, iv } = getServiceCredentials(service)
  const cipher = crypto.createCipheriv('aes-256-cbc', key, iv)
  let encrypted = cipher.update(text, 'utf8', 'base64')
  encrypted += cipher.final('base64')
  return encrypted.toString('base64')
}
export const formatCammelCaseObject = (data) =>
  data.replace(/"(\w+)"\s*:/g, (_, p1) => {
    return `"${p1[0].toLowerCase()}${p1.slice(1)}":`
  })
export function decryptData(text, service) {
  const { key, iv } = getServiceCredentials(service)
  const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv)
  let decrypted = decipher.update(text, 'base64', 'utf8')
  decrypted += decipher.final('utf8')
  return formatCammelCaseObject(decrypted.toString())
}
